var _rect, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#A4CDFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2302_7136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 28,
    height: 28
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2302_7136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 23.44C10 17.1043 10 13.9365 11.9682 11.9682C13.9365 10 17.1043 10 23.44 10H24.56C30.8957 10 34.0635 10 36.0318 11.9682C38 13.9365 38 17.1043 38 23.44V24.56C38 30.8957 38 34.0635 36.0318 36.0318C34.0635 38 30.8957 38 24.56 38H23.44C17.1043 38 13.9365 38 11.9682 36.0318C10 34.0635 10 30.8957 10 24.56V23.44Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8979 30.1717C18.5162 30.1717 14.8763 25.7967 14.7246 18.5167H17.9213C18.0263 23.8601 20.3829 26.1234 22.2496 26.59V18.5167H25.2596V23.125C27.103 22.9267 29.0394 20.8267 29.6927 18.5167H32.7028C32.2012 21.3634 30.1012 23.4634 28.6078 24.3267C30.1012 25.0267 32.493 26.8584 33.403 30.1717H30.0895C29.3779 27.955 27.6046 26.24 25.2596 26.0067V30.1717H24.8979Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialVk);
export default __webpack_public_path__ + "static/media/icon-social-vk.c1d46fe12ee9794275b2c185d4184601.svg";
export { ForwardRef as ReactComponent };